var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tenpercent"},[_c('div',{staticClass:"tenpercent_left"},[_c('p',[_vm._v("八号地旗下的朗勤心选App安卓1.0公测版上架安卓商城")])]),_c('div',{staticClass:"center_content"},[_c('div',{staticClass:"sphere"})]),_c('div',{staticClass:"tenpercent_right"},[_c('div',{staticClass:"right_bootom"}),_c('p',[_vm._v("2019.05.16")])])])
}]

export { render, staticRenderFns }